module.exports = __webpack_public_path__ + "static/media/Illus-SideProtein.70eb229f.png";